import { type ReactNode } from "react";
import { cn } from "../lib/utils";
import { Text } from "../primitives";
import { HeaderActions } from "./HeaderActions";

export type PageHeaderProps = {
	/**
	 * Left-hand content. A string renders as the standard page-title `Text` (`heading`); pass a
	 * node for custom title regions (e.g. a name + agency + scope toggle cluster).
	 */
	title: ReactNode;
	testId?: string;
	userMenu: ReactNode;
	actionButtons?: ReactNode;
	className?: string;
};

/** Owns the shared gutters, alignment, and title styling so views don't hand-roll their own header row. */
export const PageHeader = ({
	title,
	testId,
	userMenu,
	actionButtons,
	className,
}: PageHeaderProps) => (
	<div
		data-testid={testId}
		className={cn("flex items-center justify-between gap-x-4 px-8 pt-4 pb-2", className)}
	>
		<div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-3 gap-y-2">
			{typeof title === "string" ? (
				<Text type="heading" color="primary" className="whitespace-nowrap">
					{title}
				</Text>
			) : (
				title
			)}
		</div>
		<HeaderActions userMenu={userMenu} actionButtons={actionButtons} />
	</div>
);
